import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { IconCrane, IconPlus } from "@tabler/icons-react";
import { addDoc, onSnapshot } from "firebase/firestore";
import { map } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import ConexaoDb from "../../../../db/conexaoDb";
import felixAnalytics from "../../../../felixAnalytics";
import Conexao from "../../../../models/conexao";
import { SituacaoSincronizacao } from "../../../../models/enum";
import { useUsuario } from "../../../../providers/usuarioProvider";
import CardConexao from "./cardConexao";
import { useNavigate } from "react-router-dom";

export default function AbaConexoes() {
  const navigate = useNavigate();
  const [conexoes, setConexoes] = useState<Conexao[]>([]);
  const { visualizado } = useUsuario();

  useEffect(() => {
    if (!!visualizado) {
      return onSnapshot(
        new ConexaoDb().collection({ usuarioId: visualizado, conexaoId: "" }),
        (query) => setConexoes(map(query.docs, (doc) => doc.data()))
      );
    }
  }, [visualizado]);

  return (
    <Box display={"flex"} flexDirection="column">
      <Alert variant="outlined" color="warning" icon={<IconCrane />}>
        <AlertTitle>Conexões indisponíveis</AlertTitle>
        No momento, a importação automática está indisponível. Você pode
        importar suas operações através do{" "}
        <b>Upload do Extrato de Negociação da B3</b>.
      </Alert>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        py={2}
        gap={2}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Open Finance
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<IconPlus />}
          disabled
          onClick={() => {
            felixAnalytics.track("criar-conexao");

            addDoc(
              new ConexaoDb().collection({
                usuarioId: visualizado!,
                conexaoId: "",
              }),
              new Conexao({
                id: "",
                dataConexao: moment(),
                dataAtualizacao: moment("2019-10-01"),
                situacao: SituacaoSincronizacao.CRIADA,
                corretora: "",
                conta: "",
                conexaoAntiga: false,
              })
            ).then((ref) => navigate(`/arquivo/conexao/${ref.id}`));
          }}
        >
          Nova Conexão
        </Button>
      </Box>
      <Grid container spacing={2}>
        {map(conexoes, (conexao) => (
          <Grid item xs={12} md={4}>
            <CardConexao key={conexao.id} conexao={conexao} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
